export const LINE_ITEM_TYPES = {
  BALANCE_SHEET: 'Balance Sheet',
  DIRECT_CASHFLOW: 'Direct Cashflow',
  INCOME_STATEMENT: 'Income Statement',
  INDIRECT_CASHFLOW: 'Indirect Cashflow',
  OPEX_MAPPING: 'Opex Mapping',
};

export const FSLI_TYPES = LINE_ITEM_TYPES;

export const REPORTS = {
  BALANCE_SHEET: 'Balance Sheet',
  DIRECT_CASHFLOW: 'Direct Cashflow',
  INDIRECT_CASHFLOW: 'Indirect Cashflow',
  INCOME_STATEMENT: 'Income Statement',
  INCOME_STATEMENT_GAAP: 'Income Statement (GAAP)',
  INCOME_STATEMENT_NON_GAAP: 'Income Statement (non-GAAP)',
};
export const INDENT_UNITS = 3;
export const TOTAL_FSLIS = [
  'Total',
  'Net cash provided by',
  'Cash, cash equivalents and restricted cash at end of the period',
  'Effect of exchange rate changes on cash and cash equivalents',
  'Gross Profit',
  'Total Operating Expenses',
  'Income From Operations',
  'Net Profit',
  'Net Profit (Loss)',
  'Income Before Income Taxes',
  'Total Liabilities',
  'Net increase in cash and cash equivalents and restricted cash',
  'Income (Loss) Before Income Taxes',
];
export const REPORTING_STANDARDS = {
  'NON-GAAP': 'Non GAAP',
  GAAP: 'GAAP',
};

export const REPORT_TYPES = {
  BALANCE_SHEET: {
    label: 'BS',
    title: 'Balance Sheet',
    depthCorrection: -1,
  },
  INCOME_STATEMENT_GAAP: {
    label: 'I/S(GAAP)',
    title: 'Income Statement',
    depthCorrection: -1,
  },
  INCOME_STATEMENT_NON_GAAP: {
    label: 'I/S(Non-GAAP)',
    title: 'Non-GAAP Income Statement',
    depthCorrection: -1,
  },
  INDIRECT_CASHFLOW: {
    label: 'SCF(Indirect)',
    title: 'Indirect Cash Flow Statement',
    depthCorrection: -2,
  },
  DIRECT_CASHFLOW: {
    label: 'SCF(Direct)',
    title: 'Cash Flow (Direct)',
    depthCorrection: -2,
  },
};

export const CREATE_FLOWS = {
  pdf: 'PDF',
  pdfReviewAssistant: 'PDF_REVIEW_ASSISTANT',
  rollforward: 'ROLLFORWARD',
  annualRollForward: 'ANNUAL_ROLLFORWARD', // Can be removed when we remove the pdf-roll-forward flag
  annualBlankDocument: 'ANNUAL_BLANK_DOCUMENT', // Can be removed when we remove the pdf-roll-forward flag
  blankDocument: 'BLANK_DOCUMENT',
  quarterly: 'QUARTERLY',
  other: 'OTHER',
  copy: 'COPY',
  upload: 'UPLOAD',
};

export const WORKBOOK_OPTIONS = {
  existing: 'EXISTING',
  new: 'NEW',
  upload: 'UPLOAD',
};

export const CREATE_STEPS = {
  create: 'CREATE',
  processing: 'PROCESSING',
};

export const DOCUMENT_TYPES = {
  annualReport: 'ANNUAL',
  quarterlyReport: 'QUARTER',
  semiAnnualReport: 'SEMI_ANNUAL',
  other: 'OTHER',
};

export const INGESTION_STATUSES = {
  notStarted: 'NOT_STARTED',
  inProgress: 'IN_PROGRESS',
  completed: 'COMPLETED',
  failed: 'FAILED',
};

export const UPLOAD_STATUSES = {
  notStarted: 'NOT_STARTED',
  inProgress: 'IN_PROGRESS',
  completed: 'COMPLETED',
  failed: 'FAILED',
};

export const DEFAULT_TABLE_OF_CONTENTS_DATA = [
  ['', 'PAGE'],
  ['Report of Independent Auditors', '3'],
  ['Consolidated Balance Sheets', '5'],
  ['Consolidated Statements of Operations', '6'],
  ['Consolidated Statements of Changes in Stockholders Equity', '7'],
  ['Consolidated Statements of Cash Flows', '8'],
  ['Notes to Consolidated Financial Statements', '9'],
];
export const HIGHLIGHT_COLOR = 'rgb(255, 241, 169)';
export const accountColumns = [
  {field: 'accountNumber', headerName: '#', width: '5rem'},
  {field: 'accountName', headerName: 'Account', width: '20rem'},
  {field: 'accountType', headerName: 'Type', width: '5rem'},
  {
    field: 'financialStatementLineItem',
    headerName: 'Financial Statement Line Item',
    width: '20rem',
  },
  {
    field: 'includeInNonGAAPIS',
    headerName: 'Include in Non GAAP I/S',
    width: '10rem',
  },
];

export const departmentColumns = [
  {field: 'departmentName', headerName: 'Department Name', width: '20rem'},
  {
    field: 'financialStatementLineItem',
    headerName: 'Financial Statement Line Item',
    width: '20rem',
  },
];

export const ROUNDING_LABEL_OPTIONS = {
  0: '',
  1: ' thousand',
  2: ' million',
};

export const FALLBACK_SECTIONS = [
  {
    id: 'section1',
    field: 'section1',
    title: 'Cover Page',
    defaultContent:
      '<h1>Cover Page</h1><p>Company Name</p><p>Financial Statements</p><p>For the Year Ended [Date]</p>',
    sortOrder: 10,
    index: 0,
  },
  {
    id: 'section2',
    field: 'section2',
    title: 'Table of Contents',
    defaultContent:
      '<h1>Table of Contents</h1><p>Contents will be auto-generated...</p>',
    sortOrder: 20,
    index: 1,
  },
  {
    id: 'section3',
    field: 'section3',
    title: 'Report of Independent Auditors',
    defaultContent:
      "<h1>Report of Independent Auditors</h1><p>Independent auditor's report content...</p>",
    sortOrder: 30,
    index: 2,
  },
  {
    id: 'section4',
    field: 'section4',
    title: 'Consolidated Balance Sheets',
    defaultContent:
      '<h1>Consolidated Balance Sheets</h1><p>Balance sheet content...</p>',
    sortOrder: 40,
    index: 3,
  },
  {
    id: 'section5',
    field: 'section5',
    title: 'Consolidated Statements of Operations',
    defaultContent:
      '<h1>Consolidated Statements of Operations</h1><p>Income statement content...</p>',
    sortOrder: 50,
    index: 4,
  },
  {
    id: 'section6',
    field: 'section6',
    title: "Consolidated Statements of Changes in Stockholder's Equity",
    defaultContent:
      "<h1>Consolidated Statements of Changes in Stockholder's Equity</h1><p>Equity changes content...</p>",
    sortOrder: 60,
    index: 5,
  },
  {
    id: 'section7',
    field: 'section7',
    title: 'Consolidated Statements of Cash Flows',
    defaultContent:
      '<h1>Consolidated Statements of Cash Flows</h1><p>Cash flow statement content...</p>',
    sortOrder: 70,
    index: 6,
  },
  {
    id: 'section8',
    field: 'section8',
    title: 'Notes to Consolidated Financial Statements',
    defaultContent:
      '<h1>Notes to Consolidated Financial Statements</h1><p>Notes to financial statements...</p>',
    sortOrder: 80,
    index: 7,
  },
];

export const PSO_ICON_COLORS = [
  // Original 12 colors (revised)
  '#2A6B65',
  '#34A290',
  '#C5D96A',
  '#E5DC6B',
  '#E0488A',
  '#E05665',
  '#E87872',
  '#FF8F1A',
  '#FAB394',
  '#F9D05E',
  '#7C5FD3',
  '#7D4D87',
  // Extended palette - Blues/Teals
  '#1A7FE6',
  '#3399FF',
  '#5CB3FF',
  '#80C5FF',
  '#1A95A3',
  '#00B8C8',
  '#1AD4E2',
  '#72D9DD',
  // Greens
  '#43914A',
  '#4DA355',
  '#5CB862',
  '#7AC87D',
  '#93D696',
  '#66C069',
  '#9DD15E',
  // Purples/Violets
  '#9333B8',
  '#A445C0',
  '#B454CC',
  '#C167D8',
  '#CE7FE0',
  '#8165AC',
  '#9D72F8',
  // Reds/Pinks
  '#D94545',
  '#E25555',
  '#ED6565',
  '#F57C7C',
  '#F0407A',
  '#F45E8E',
  '#F77BA5',
  // Browns/Oranges
  '#D95528',
  '#E6663A',
  '#F2744A',
  '#FF845C',
  '#FF8A1A',
  '#FFA31A',
  '#FFB31A',
  // Additional unique colors
  '#8C6E5F',
  '#856656',
  '#5A7280',
];

export const ROLE_COLORS = {
  Owner: '#DEF1E9',
  'Report Preparer': '#D2EEFF',
  Admin: '#FFEECC',
  Reviewer: '#F1D6FF',
  default: '#DEF1E9',
};

export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  SGD: 'S$',
  CHF: '₣',
};

export const FOLDER_YEARS = [
  `${new Date().getFullYear() + 2}`,
  `${new Date().getFullYear() + 1}`,
  `${new Date().getFullYear()}`,
  `${new Date().getFullYear() - 1}`,
  `${new Date().getFullYear() - 2}`,
  `${new Date().getFullYear() - 3}`,
];

export const FOLDER_PURPOSES = {
  regular: 'document-workspace',
  pdfReview: 'pdf-audit-workspace',
};

export const DOCUMENT_INGESTION_TYPES = {
  pdfReview: 'pdf-audit',
};

export const DOCUMENT_PAGE_NUMBER_WARNING_MESSAGE =
  'Always use the Document Page Number provided by Inscope. Do not reference the printed page number in the footer.';

export const PAGE_NUMBER_ALIGN_ITEMS_MAP = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

// Convert pt to px (1pt = 1.333px approximately, or 96/72)
export const PT_TO_PX = 96 / 72;
